/**
 * Constants related to items filtering
 */
export const SKIPPABLE_REGION_MINIMUM_DURATION = 6;
